import { Button } from 'react-bootstrap';
import { isMobile, MobileView } from 'react-device-detect';
import JobListLoader from '@company/components/JobList/JobListLoader';
import JobTable from '@company/components/JobList/JobTable/JobTable';
import ThPagination from '@components/ThPagination/ThPagination';
import IJobDetail, { IJobsData, JobMember } from '@th-types/job.detail.type';
import { IJobStatsList } from '@th-types/jobs.type';
import { DEFAULT_ITEMS_PER_PAGE } from '@utils/Pagination';

interface Props {
  jobList?: IJobsData;
  jobStatsList?: IJobStatsList;
  isFetchingJobs: boolean;
  isFetchingJobStatsList: boolean;
  hideJob: (job: IJobDetail) => void;
  showJobMembers: (members: JobMember[]) => void;
  setCurrentOffset: (currentOffset: number) => void;
  handleOpenModalShareJobLink: (job: IJobDetail) => void;
}

const SERVER_URL = import.meta.env.VITE_SERVER_BASE_URL;

export default function JobListView({
  jobList,
  jobStatsList,
  isFetchingJobs,
  isFetchingJobStatsList,
  hideJob,
  showJobMembers,
  setCurrentOffset,
  handleOpenModalShareJobLink,
}: Props) {
  if (isFetchingJobs || isFetchingJobStatsList) {
    return <JobListLoader />;
  }
  if (jobList && jobList.results?.length > 0 && jobStatsList) {
    return (
      <>
        <JobTable
          jobList={jobList.results}
          jobStatsList={jobStatsList}
          hideJob={hideJob}
          showJobMembers={showJobMembers}
          handleOpenModalShareJobLink={handleOpenModalShareJobLink}
        />

        <div
          className={`${isMobile ? 'mb-5 mt-3' : 'mt-auto'}`}
          data-testid="th-pagination"
        >
          <ThPagination
            currentOffset={jobList.pagination.offset}
            onPageChange={setCurrentOffset}
            itemsPerPage={DEFAULT_ITEMS_PER_PAGE}
            totalItems={jobList.pagination.count}
            data-testid="th-pagination"
          />
        </div>

        <MobileView>
          <div className="d-flex mx-3 mt-2">
            <a
              href={`${SERVER_URL}/job/create`}
              target="_blank"
              rel="noreferrer"
            >
              <Button
                variant="primary"
                style={{ position: 'fixed', top: '95%', width: '92%' }}
              >
                <strong>CREATE JOB</strong>
              </Button>
            </a>
          </div>
        </MobileView>
      </>
    );
  }

  if (jobList && jobList.results?.length === 0) {
    return (
      <div
        className={`d-flex justify-content-center align-items-center ${isMobile ? 'ms-4 mt-4 me-4' : 'mt-3 flex-column'}`}
      >
        No results, please clear your quick filters or select a different one
      </div>
    );
  }
  return null;
}
